/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
import { commentCollectionsConfig } from './CommentCollectionsConfig';
// Material UI Components
import { lighten } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import {
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator
} from '@mui/lab';
import Typography from '@mui/material/Typography';
import Timeline from '@mui/lab/Timeline';
// Custom Components
import moment from 'moment';
import authRoles from '../../auth/authRoles';
import ReplyContentCard from './ReplyContentCard';

function ReplyItem(props) {
  const { reply, last, user, searchText, isIMI = false, resource, collection = 'comments' } = props;

  const internalCycles = commentCollectionsConfig[collection]?.internalCycles || [];

  const filteredReplies = reply.replies.filter(
    (replyToThis) =>
      authRoles.editor.includes(user.role) ||
      !internalCycles.includes(replyToThis?.review?.cycle)
  );

  return (
    <TimelineItem>
      <TimelineSeparator>
        <TimelineDot className="my-8 flex h-24 w-24 items-center justify-center p-0 shadow-none">
          <Avatar
            sx={{
              backgroundColor: reply.creator.settings.color,
              color:
                reply.creator.settings.color != '#013BB1' &&
                reply.creator.settings.color != '#481FA7'
                  ? 'common.black'
                  : 'common.white',
              width: 24,
              height: 24
            }}
            className="text-12 font-bold"
          >
            {reply.creator.first_name[0]}
            {reply.creator.last_name[0]}
          </Avatar>
        </TimelineDot>

        {!last && <TimelineConnector />}
      </TimelineSeparator>

      <TimelineContent className="flex flex-col items-start p-0 pb-16">
        <Typography className="text-14 font-bold pl-16">
          {reply.creator.first_name} {reply.creator.last_name}
        </Typography>
        <Typography color="text.secondary" className="text-12 mb-16 pl-16">
          {reply.updated_date
            ? moment
                .utc(reply.updated_date)
                .local()
                .format('MMM DD, YYYY, h:mm A z')
            : 'No date available'}
        </Typography>
        <ReplyContentCard
          comment={reply}
          user={user}
          searchText={searchText}
          isIMI={isIMI}
          resource={resource}
          collection={collection}
        />
        {filteredReplies.length > 0 && (
          <Box
            className="card-footer flex flex-col p-0 border-t-1 w-full"
            sx={{
              backgroundColor: (theme) =>
                theme.palette.mode === 'light'
                  ? lighten(theme.palette.background.default, 0.4)
                  : lighten(theme.palette.background.default, 0.02)
            }}
          >
            <Timeline
              className="p-0 py-16"
              position="right"
              sx={{
                '& .MuiTimelineItem-root:before': {
                  display: 'none'
                }
              }}
            >
              {filteredReplies.map((replyToThis, index) => (
                <ReplyItem
                  key={replyToThis.id}
                  reply={replyToThis}
                  last={reply.replies.length === index + 1}
                  user={user}
                  searchText={searchText}
                  resource={resource}
                  isIMI={isIMI}
                  collection={collection}
                />
              ))}
            </Timeline>
          </Box>
        )}
      </TimelineContent>
    </TimelineItem>
  );
}

export default ReplyItem;
